// Chat bots (timers, command replies, ads) — never a reaction to the stream. Left out of what the
// AI sees: AI Deep bins (utils/deep-bins.ts) and the «Речь» «+ чат» payload (utils/transcript.ts).
// Server mirror: BOT_RE in cloud-run-api/lib/deep.js — tools/test-deep.mjs fails if they differ.
export const CHAT_BOT_RE = /^(nightbot|streamelements|moobot|fossabot|wizebot|streamlabs|botrix|sery_bot|soundalerts|kofistreambot|pokemoncommunitygame|deepbot|coebot|vivbot|phantombot|ankhbot|stay_hydrated_bot|commanderroot)$/i;

export function isChatBot(name: string | null | undefined): boolean {
  return !!name && CHAT_BOT_RE.test(name);
}
